import { render } from "./ClientStandardList.vue?vue&type=template&id=60a8a922&scoped=true"
import script from "./ClientStandardList.vue?vue&type=script&lang=js"
export * from "./ClientStandardList.vue?vue&type=script&lang=js"

import "./ClientStandardList.vue?vue&type=style&index=0&id=60a8a922&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a8a922"]])

export default __exports__